export function verifyNoCollisions(...objs) {
  const methods = objs.reduce((r, obj) => r.concat(Object.keys(obj)), []);
  const hasCollisions = methods.some((method, i) => {
    return method.indexOf(method, i + 1) !== -1;
  });
  if (hasCollisions) {
    throw new Error('Colliding methods found in extension objects.');
  }
}
